import NoResults from 'components/Error/NoResults';
import Error from 'components/Error/RequestFailure';

const DEFAULT_REQUEST_VIEWS = {
  error: ({ onRetry, errorProps }) => <Error retryCallback={onRetry} {...errorProps} />,
  empty: () => <NoResults />,
};

const RequestBoundary = ({ isError, isEmpty, isLoading, onRetry, views = {}, children }) => {
  const mergedViews = {
    ...DEFAULT_REQUEST_VIEWS,
    ...views, // overrides
  };

  if (isError) {
    return mergedViews.error({ onRetry });
  }

  if (!isLoading && isEmpty) {
    return mergedViews.empty();
  }

  return children;
};

export default RequestBoundary;
